import { render, staticRenderFns } from "./TransitionExpandSide.vue?vue&type=template&id=1ed0e8b6&"
import script from "./TransitionExpandSide.vue?vue&type=script&lang=js&"
export * from "./TransitionExpandSide.vue?vue&type=script&lang=js&"
import style0 from "./TransitionExpandSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports